import { dateToString } from "utils/dateUtils";
import countries from "utils/static/countries";

function newDate(millis) {
    return millis ? new Date(millis) : null;
}

export const Immigration_Single = (item) => {
    const {
        startDate: startDateInMillis,
        dateOfEntry: dateOfEntryInMillis,
        client: { country: countryCode, birthDate: birthDateInMillis },
    } = item;
    const startDate = newDate(startDateInMillis);
    const dateOfEntry = newDate(dateOfEntryInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;
    const birthDate = newDate(birthDateInMillis);
    return {
        ...item,
        startDate,
        startDateString: dateToString(startDate, false),
        dateOfEntry,
        dateOfEntryString: dateToString(dateOfEntry, false),
        client: {
            ...item.client,
            birthDate,
            birthDateString: dateToString(birthDate, false),
            country,
        },
    };
};

export const Immigration = (data) => {
    if (data && Array.isArray(data) && data.length > 0) {
        return data.map(Immigration_Single);
    }
};

export const Taxes_Single = (item) => {
    const {
        startDate: startDateInMillis,
        client: { country: countryCode, birthDate: birthDateInMillis },
    } = item;
    const startDate = newDate(startDateInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;
    const birthDate = newDate(birthDateInMillis);
    return {
        ...item,
        startDate,
        startDateString: dateToString(startDate, false),
        client: {
            ...item.client,
            birthDate,
            birthDateString: dateToString(birthDate, false),
            country,
        },
    };
};

export const Taxes = (data) => {
    if (data && Array.isArray(data) && data.length > 0) {
        return data.map(Taxes_Single);
    }
};

export const Crime_Single = (item) => {
    const {
        startDate: startDateInMillis,
        dateOfArrest: dateOfArrestInMillis,
        courtDate: courtDateInMillis,
        client: { country: countryCode, birthDate: birthDateInMillis },
    } = item;
    const startDate = newDate(startDateInMillis);
    const dateOfArrest = newDate(dateOfArrestInMillis);
    const courtDate = newDate(courtDateInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;
    const birthDate = newDate(birthDateInMillis);
    return {
        ...item,
        startDate,
        startDateString: dateToString(startDate, false),
        dateOfArrest,
        dateOfArrestString: dateToString(dateOfArrest),
        courtDate,
        courtDateString: dateToString(courtDate),
        client: {
            ...item.client,
            birthDate,
            birthDateString: dateToString(birthDate, false),
            country,
        },
    };
};

export const Crime = (data) => {
    if (data && Array.isArray(data) && data.length > 0) {
        return data.map(Crime_Single);
    }
};

export const Injury_Single = (item) => {
    const {
        startDate: startDateInMillis,
        dateOfAccident: dateOfAccidentInMillis,
        client: { country: countryCode, birthDate: birthDateInMillis },
    } = item;
    const startDate = newDate(startDateInMillis);
    const dateOfAccident = newDate(dateOfAccidentInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;
    const birthDate = newDate(birthDateInMillis);
    return {
        ...item,
        startDate,
        startDateString: dateToString(startDate, false),
        dateOfAccident,
        dateOfAccidentString: dateToString(dateOfAccident),
        client: {
            ...item.client,
            birthDate,
            birthDateString: dateToString(birthDate, false),
            country,
        },
    };
};

export const Injury = (data) => {
    if (data && Array.isArray(data) && data.length > 0) {
        return data.map(Injury_Single);
    }
};

export const Family_Single = (item) => {
    const {
        startDate: startDateInMillis,
        dateOfMarriage: dateOfMarriageInMillis,
        dateOfSeparation: dateOfSeparationInMillis,
        respondentDob: respondentDobInMillis,
        client: { country: countryCode, birthDate: birthDateInMillis },
    } = item;
    const startDate = newDate(startDateInMillis);
    const dateOfMarriage = newDate(dateOfMarriageInMillis);
    const dateOfSeparation = newDate(dateOfSeparationInMillis);
    const respondentDob = newDate(respondentDobInMillis);
    const country = countryCode ? countries.find((x) => x.code === countryCode) : null;
    const birthDate = newDate(birthDateInMillis);
    return {
        ...item,
        startDate,
        startDateString: dateToString(startDate, false),
        dateOfMarriage,
        dateOfAccidentString: dateToString(dateOfMarriage),
        dateOfSeparation,
        respondentDob,
        client: {
            ...item.client,
            birthDate,
            birthDateString: dateToString(birthDate, false),
            country,
        },
    };
};

export const Family = (data) => {
    if (data && Array.isArray(data) && data.length > 0) {
        return data.map(Family_Single);
    }
};
